<template>
	<div class="label-node">
		<Handle type="target" :position="Position.Left" :connectable="false" style="opacity: 0" />
		<span>{{ label }}</span>
	</div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import { Handle, Position } from '@vue-flow/core';

export default defineComponent({
	name: 'LabelNode',
	components: {
		Handle,
	},
	props: {
		label: {
			type: String,
		},
	},
	setup() {
		return {
			Position,
		};
	},
});

</script>

<style scoped>

.label-node {
	height: 100%;
	width: 100%;
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
	gap: 10px;
	background: white;
	border: 1px solid black;
	border-radius: 4px;
}

</style>
